import {
  CHALLENGE_ENDING_DATE,
  CHALLENGE_STARTING_DATE
} from 'helpers/challenge/getChallengeInfos';
import { ID, OPERATION_ID } from '../typeDef';
import { ProfileInfoExtended } from '../user/user.def';

export const maxClasseDateChallenge = CHALLENGE_ENDING_DATE;
export const minClasseDateChallenge = CHALLENGE_STARTING_DATE;

export const initialClasseState: ClasseDefTypes = {
  classeName: null,
  filliere: null,
  niveau: null,
  debut: minClasseDateChallenge,
  fin: maxClasseDateChallenge
};

export interface ClasseInfo {
  lycee: {
    name: string;
  };
  filliere: {
    name: string;
  };
  niveau: {
    name: string;
  };
}

export interface ClasseDef extends ClasseInfo {
  id?: ID;
  debut: string;
  fin: string;
  operationid: OPERATION_ID;
  name: string;
}

export type ClasseDefWithUser = ClasseDef & {
  users: ProfileInfoExtended[];
  orderNeedToBeReminded?: number;
};

export interface ClasseDate {
  debut: string;
  fin: string;
}

export interface ClasseDefTypes extends ClasseDate {
  classeName: string;
  filliere: ID;
  niveau: ID;
}
